module.exports = __webpack_public_path__ + "static/second-d9963b610227da23af9bc3b4b8f25241.jpg";